import { type FC, useMemo } from 'react';
import { getIsLineStatusClosed, getMatchScore, useLineBehaviorV2, useMatchStatus, useMatchTime } from '@mwl/core-lib';
import { SportClock } from '@/components/SportClock/SportClock';
import { routes } from '@/constants';
import { MatchStatus } from '../MatchStatus/MatchStatus';
import { MatchTeam } from '../MatchTeam/MatchTeam';
import type { MatchTeamProps } from '../MatchTeam/MatchTeam.types';
import { MatchTimer } from '../MatchTimer/MatchTimer';
import { MatchLive } from './components/MatchLive/MatchLive';
import type { MatchCompetitorsProps } from './MatchCompetitors.types';
import styles from './MatchCompetitors.module.scss';
export const MatchCompetitors: FC<MatchCompetitorsProps> = ({
  line,
  imageOnly,
  className,
  mobileSize = 'normal'
}) => {
  const {
    competitors,
    singleCompetitor
  } = useLineBehaviorV2({
    line,
    routes
  });
  const commonTeamProps = useMemo<MatchTeamProps>(() => {
    return {
      imageOnly,
      className: styles.competitor,
      sportIcon: line.sport.icon,
      imageSize: mobileSize === 'normal' ? 40 : 20,
      classes: {
        name: cn(styles.competitorName, {
          [styles.small]: mobileSize === 'small'
        })
      }
    };
  }, [imageOnly, line.sport.icon, mobileSize]);
  const {
    stage
  } = line;
  const status = useMatchStatus(line);
  const time = useMatchTime(line, SportClock);
  const score = getMatchScore(line);
  const isClosed = getIsLineStatusClosed(line);
  return <div className={cn(styles.root, {
    [styles.singleCompetitor]: !!singleCompetitor
  }, className)} data-sentry-component="MatchCompetitors" data-sentry-source-file="MatchCompetitors.tsx">
      <MatchTeam {...commonTeamProps} className={styles.homeTeam} team={singleCompetitor ?? competitors.HOME} data-sentry-element="MatchTeam" data-sentry-source-file="MatchCompetitors.tsx" />
      {stage === 'LIVE' && <MatchLive line={line} status={status} time={time} score={score} singleCompetitor={!!singleCompetitor} />}
      {stage === 'PREGAME' && typeof time === 'string' && <>
          <MatchStatus status={status} className={styles.matchStatus} />
          <MatchTimer matchClosed={isClosed} time={time} className={styles.matchTimer} />
        </>}
      {!singleCompetitor && <MatchTeam {...commonTeamProps} className={styles.awayTeam} team={competitors.AWAY} />}
    </div>;
};